import { useMemo, useEffect } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { updateSettings } from '../../../../../../../store/actions/creator/analysis';
import ScorePane from '../../../analysis/completed/graph/scorePane';
import UtilService from '../../../../../../../helper/service';
import CoreAnalysisBarGraph from '../../../analysis/completed/graph/bar';
import CoreAnalysisLineBarGraph from '../../../analysis/completed/graph/linebar';
import KnownOverviewLineBarGraph from './knownOverviewLinebar';


import useWindowSize from '../../../../../../../helper/hooks/useWindowSize';
import OverviewPill from './pills';

function KnownGraphAreaSection(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { graphType, graphBackground, thumbnailImage, immersionData, confidenceScore } = props;
//console.log(`thumb is: ${thumbnailImage}`);
  const { currentSession, all, identifiers, cliped, analyseStart, analyseEnd, excludedParticipants, stimulus, settings } = useSelector((state: any) => state.analysis);
  const { graphZoom, clip  } = settings;
  const { session_status, session_type } = currentSession;

  const { width } = useWindowSize();
  const paneWidth = (width && width > 0 && width < 2000) ? width / 1.4 - 160 : 900;

  const graphLength = useMemo(() => {
    if (cliped && stimulus) return (cliped.end_clip - cliped.start_clip) + 1;
    if (stimulus && session_type === 'ASYNC') return stimulus.stimulus_video_length;
    if (cliped) return (cliped.end_clip - cliped.start_clip) + 1;
    return analyseEnd - analyseStart
  }, [stimulus, cliped, analyseEnd, analyseStart]);

  //console.log(graphZoom);
  const getMaxWidth = Math.floor(graphLength / Math.pow(graphZoom, 2) * 15);
  //const getMaxWidth = 900;

  const graphs = all
    .filter((item: any) =>
      !excludedParticipants.includes(item.activeParticipant) &&
      (identifiers.includes(item.activeParticipant) || item.activeParticipant === 'All' || item.isTag)
    )
    .map((item: any) => (cliped ? {
      ...item, immersion: {
        ...item.immersion, data: item.immersion.data.filter((datum: any) => {
          return UtilService.getLocalEpoch2(datum.time_stamp) >= cliped.start_clip && UtilService.getLocalEpoch2(datum.time_stamp) <= cliped.end_clip
        })
      },
    } : item))
    .map((item: any) => (cliped ? {
      ...item, pills: item.pills.filter((datum: any) => {
        return (
          (cliped.start_clip <= datum.start && datum.start <= cliped.end_clip)
          || (cliped.start_clip <= datum.end && datum.end <= cliped.end_clip)
          || (datum.start <= cliped.start_clip && cliped.end_clip <= datum.end)
        )
      })
    } : item))
    .map((item: any) => (cliped ? {
      ...item, safety: item.safety.filter((datum: any) => {
        return datum.epoch_start + 120 >= cliped.start_clip && datum.epoch_start <= cliped.end_clip
      })
    } : item));
  
  const graphData = graphs[0];

  if (!graphData) {
    return null
  }

//console.log(pdfLoading);

  useEffect(() => {
    if (analyseEnd && analyseStart && graphLength) {
      dispatch(updateSettings('graphZoom', Math.sqrt(graphLength * 15 / paneWidth)));
    }
  }, [analyseEnd, analyseStart, width, cliped, clip, stimulus]);

  return (
    <Grid item xs={12} >

      {!clip &&
        <div className={classes.graphSection} >

          <div
            className={classes.pane}
            style={{ marginTop: 0 }}
          >
              <div id={'scorepane'}>
                {graphBackground === 0 && <ScorePane
                  sessionStatus={session_status}
                  immersionData={graphData.immersion}
                  participant={graphData.activeParticipant}
                  graphWidth={paneWidth}
                  overview={true}
                />}
                {graphBackground === 1 && <ScorePane
                  sessionStatus={session_status}
                  participant={graphData.activeParticipant}
                  safetyOverall={graphData.overall_safety}
                  graphWidth={paneWidth}
                  overview={true}
                />}

                {graphBackground === 3 && 
                  <>
                  <div id={'gb3'} style={{backgroundImage: `url(${thumbnailImage})`, backgroundColor: '#000000', backgroundSize: 'cover', backgroundPosition: 'center', width: getMaxWidth, height: '500px'}}></div>

                  
                  </>}






              </div>
          </div>

          <div style={{ width: paneWidth, height: 600 }}>
            <div style={{ width: getMaxWidth,  height: 600, marginTop: all.length > 0 ? 0 : 0 }}>
              <div style={{position: 'relative'}}>

                {graphType === 0 && <CoreAnalysisLineBarGraph overview={true} width={getMaxWidth} height={paneWidth / 4.5} graphData={graphData.immersion} />}
                {graphType === 0 && <OverviewPill graphWidth={getMaxWidth} graphData={graphData} />}
                {graphType === 1 && <CoreAnalysisBarGraph graphData={graphData.safety} />}

                {graphType === 3 && <KnownOverviewLineBarGraph clip={1} marginTop={0} forceHeight={506} overview={true} width={getMaxWidth} height={506} graphData={graphData.immersion} />}
                {graphType === 3 && <OverviewPill graphWidth={getMaxWidth} graphData={graphData} />}  

                  <div id={'immbox'} className={classes.immbox}>
                    <p className={classes.boxScoreValue}>{ !!immersionData ? immersionData.immersion_index : "--" }</p>
                    <p className={classes.boxScoreLabel}>Immersion</p>
                  </div>
                  <div id={'conbox'} className={classes.conbox}>
                    <p className={classes.boxScoreValue}>{!!confidenceScore && confidenceScore}</p>
                    <p className={classes.boxScoreLabel}>Confidence</p>
                  </div>
              </div>
            </div>
          </div>

        </div>
      }

    </Grid>
  );
}

export default KnownGraphAreaSection;

const useStyles = makeStyles(() => ({
  container: {
    flex: 1,
    display: 'flex',
    //marginLeft: -310,
    //marginTop: -100,
  },
  immbox: {
    width: '100px', 
    background: '#00000099', 
    padding: '5px', 
    position: 'absolute', 
    display: 'block', 
    top: '-5px', 
    textAlign: 'center', 
    borderBottomRightRadius: '25%',
  },
  conbox: {
    width: '100px', 
    background: '#00000099', 
    padding: '5px', 
    position: 'absolute', 
    display: 'block', 
    top: '-5px', 
    right: '0px', 
    textAlign: 'center', 
    borderBottomLeftRadius: '25%',
  },
  boxScoreValue: {
    margin: '0px', 
    paddingTop: '10px',
    fontSize: '50px', 
    color: '#fff',
    fontFamily: 'Spartan-extrabold',
  },
  boxScoreLabel: {
    margin: '0px', 
    fontSize: '10px', 
    color: '#fff'
  },
  graphSection: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    overflow: 'hidden',
    scrollbarWidth: 'none',
    //marginRight: -310,
  },
 
  pane: {
    position: 'absolute',
  },
}));